import _ from 'underscore';

import ChangeScopeTypes from 'bundles/author-course/constants/ChangeScopeTypes';
import { HONORS } from 'bundles/author-course/constants/TrackIds';
import {
  canModifyAndDeleteLesson,
  getAuthoringAtomForAtomId,
  getEmbeddedSourceCourseIdForAtomId,
} from 'bundles/author-course/utils/CourseMaterialUtils';

import Item from './Item';

export type ParentIdsForItemId = {
  [itemId: string]: {
    parentLessonId: string;
    parentModuleId: string;
  };
};

// TODO: Typing for this model is not finished.
class Lesson {
  declare id: string;

  declare moduleId: string;

  declare trackId: string;

  declare name: string;

  declare items: Array<Item>;

  declare context: any;

  declare isUpdated: boolean;

  declare elements: Array<any>;

  constructor({
    moduleId,
    id,
    trackId,
    name,
    elements,
    context,
    drafts,
    authoringAtoms,
    authoringAtomRelations,
  }: $TSFixMe) {
    this.moduleId = moduleId;
    this.id = id;
    this.trackId = trackId;
    this.name = name;
    this.items = [];
    this.context = context;

    const { changeScope } = context;
    this.isUpdated =
      !changeScope ||
      changeScope.some((scope: $TSFixMe) => {
        return this.checkIfUpdated(scope);
      });

    elements.forEach((element: $TSFixMe) => {
      const base = {
        context,
        moduleId,
        lessonId: id,
        drafts,
        isHonors: this.isHonors,
      };

      this.items.push(
        new Item(
          Object.assign(
            base,
            getAuthoringAtomForAtomId(element.atomId, authoringAtoms),
            getEmbeddedSourceCourseIdForAtomId(element.atomId, authoringAtomRelations),
            element
          )
        )
      );
    });

    // Keeping elements in the model for backward compatibility
    this.elements = elements;
  }

  get isHonors() {
    return this.trackId === HONORS;
  }

  get hasGradedItem() {
    return !!this.items.find((item) => item.isGraded);
  }

  get hasDraft() {
    return _(this.items).some((item) => item.isDraft);
  }

  get isDeletable() {
    return canModifyAndDeleteLesson(this, this.context.isBranchLaunched);
  }

  checkIfUpdated(scope: $TSFixMe) {
    const { typeName, definition } = scope;

    switch (typeName) {
      case ChangeScopeTypes.Item.LOCKS:
        return true;

      case ChangeScopeTypes.Lesson.LESSON:
        return definition.lessonId === this.id;

      // The parent lesson needs to be updated as all of these change scopes affect child components
      // Such as lesson groups, lesson group choices, items etc.
      case ChangeScopeTypes.Lesson.LESSON_ELEMENT_LISTING:
      case ChangeScopeTypes.Item.ITEM:
        return definition.parentLessonId === this.id;

      default:
        return false;
    }
  }

  getParentIdsForItems(itemIds: Array<string>) {
    return this.items.reduce((prevParentIds, item) => {
      return Object.assign(prevParentIds, item.getParentIdsForItems(itemIds));
    }, {} as ParentIdsForItemId);
  }

  updateDrafts(drafts: $TSFixMe, draftsWithParentIds: $TSFixMe) {
    const draftsInLesson = _(drafts).pick((draftName, draftId) => {
      return draftsWithParentIds[draftId].parentLessonId === this.id;
    });

    if (_(draftsInLesson).isEmpty()) {
      return;
    }

    this.isUpdated = true;

    this.items.forEach((item) => {
      item.updateDrafts(draftsInLesson);
    });
  }
}

export default Lesson;
